/*
  <variant-availability> - MMML custom
  Keeps the PDP title badge, the coming-soon / sold-out panels and the sticky add-to-cart bar in sync with the
  selected variant. Markup and state map are rendered by snippets/product-info.liquid; states come from the
  variant metafields custom.coming_soon / custom.sold_out. Listens to Prestige's "variant:change" event
  (dispatched by <variant-picker> on the product form, detail: { formId, variant, previousVariant }).
  Loaded from theme.liquid with `defer`, so it also covers quick-buy drawers on collection pages.
  CSS lives in niccos.css: variant-availability { display: contents } and
  product-sticky-bar[data-availability-blocked] { display: none !important }.
*/
(function () {
  if (window.customElements.get('variant-availability')) return;

  class VariantAvailability extends HTMLElement {
    connectedCallback() {
      this._formId = this.getAttribute('form-id') || '';
      try {
        this._states = JSON.parse(this.getAttribute('states') || '{}');
      } catch (e) {
        this._states = {};
      }

      this._onVariantChange = (event) => {
        const detail = event.detail || {};
        if (!detail.variant) return;
        if (!this._formId || detail.formId !== this._formId) return; // only our own product form
        this.update(detail.variant);
      };
      document.addEventListener('variant:change', this._onVariantChange);

      const initial = this.getAttribute('state') || 'buy';
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this._applyStickyBar(initial), { once: true });
      } else {
        this._applyStickyBar(initial);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    update(variant) {
      const state = this._states[String(variant.id)] || 'buy';
      this.setAttribute('state', state);
      this.setAttribute('available', variant.available === false ? 'false' : 'true');

      let revealedKlaviyoPanel = false;
      this.querySelectorAll('[data-availability-panel]').forEach((panel) => {
        const show = panel.dataset.availabilityPanel === state;
        if (show && panel.hidden && panel.querySelector('[class*="klaviyo-form-"]')) revealedKlaviyoPanel = true;
        panel.hidden = !show;
      });
      // A Klaviyo embed rendered while its panel was display:none may have measured a 0px width; nudge it to re-layout.
      if (revealedKlaviyoPanel) window.dispatchEvent(new Event('resize'));

      let badge = '';
      if (state === 'coming_soon') badge = 'coming_soon';
      else if (state === 'sold_out' || variant.available === false) badge = 'sold_out';

      this.querySelectorAll('[data-availability-badge]').forEach((list) => {
        list.hidden = badge === '';
        list.querySelectorAll('[data-badge-label]').forEach((label) => {
          label.hidden = label.dataset.badgeLabel !== badge;
        });
      });

      this._applyStickyBar(state);
    }

    _applyStickyBar(state) {
      if (!this._formId) return;
      document.querySelectorAll('product-sticky-bar[form="' + this._formId + '"]').forEach((bar) => {
        bar.toggleAttribute('data-availability-blocked', state !== 'buy');
      });
    }
  }

  window.customElements.define('variant-availability', VariantAvailability);
})();
